import {
  useV2ListProjectPhasesForAccountQuery,
  useV2ListServiceCategorysForAccountQuery,
} from "@generated";

export interface SelectOption {
  value: string;
  label: string;
}

// Shared with callers that read the same lists imperatively, so they hit the
// same RTK Query cache entries.
export const projectResourcesArgs = (projectId: string) => ({
  page: { size: 1000 },
  filter: { project: Number(projectId), active: true } as any,
});
// include: ["phase"] makes the API send each project phase's catalog phase
// linkage, which callers use to match catalog services to project phases.
export const projectPhasesArgs = (projectId: string) => ({
  page: { size: 1000 },
  filter: { project: Number(projectId), active: true },
  include: ["phase" as const],
});

// Service categories and LOBs share one tree; the LOB is the parent of a
// service category, so /v2/service-categories (nested-name) covers both.
export function useServiceValueOptions(projectId: string, enabled: boolean) {
  const skip = { skip: !enabled };

  const phasesQuery = useV2ListProjectPhasesForAccountQuery(
    projectPhasesArgs(projectId),
    skip
  );
  const categoriesQuery = useV2ListServiceCategorysForAccountQuery(
    { page: { size: 1000 }, filter: { active: true }, sort: ["nested-name"] },
    skip
  );

  const phases: SelectOption[] = (phasesQuery.data?.data ?? []).map((p) => ({
    value: String(p.id),
    label: p.attributes?.name ?? "",
  }));
  const serviceCategories: SelectOption[] = (
    categoriesQuery.data?.data ?? []
  ).map((c) => ({
    value: String(c.id),
    label: c.attributes["nested-name"] ?? c.attributes.name,
  }));

  return {
    phases,
    serviceCategories,
    isLoading: phasesQuery.isLoading || categoriesQuery.isLoading,
  };
}

export default useServiceValueOptions;
